module.exports = __webpack_public_path__ + "static/media/keyword-x.b373aee7.svg";